export default function handleNavigation(history, location) {
  history.push(`${location}`)
}